import { RootState } from '@reducers/index';

export const getConflictManagementCurrentTab = (state: RootState): string =>
    state.conflictManagementReducer.currentTab;
